
import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Scroll to top when location changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Set the background based on the current page and scroll position
  const navBackground = isHomePage 
    ? (isScrolled ? 'bg-knightblack/95 shadow-lg backdrop-blur-md' : 'bg-knightblack/70')
    : 'bg-knightblack shadow-lg';

  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${navBackground} ${isScrolled ? 'py-3' : 'py-5'}`}>
      <div className="max-w-7xl mx-auto px-4 flex justify-between items-center">
        {/* Logo */}
        <div className="flex items-center">
          <Link to="/">
            <img src="/lovable-uploads/0aa296c2-39b8-4316-97b8-2a5754cf1180.png" alt="GoldCrusade Knight Logo" className="h-10 w-auto mr-2" />
          </Link>
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center justify-between w-full ml-10">
          <div className="flex space-x-6">
            <Link to="/solutions" className="text-softwhite hover:text-goldcore transition-colors">Solutions</Link>
            <Link to="/insights" className="text-softwhite hover:text-goldcore transition-colors">Insights</Link>
            <Link to="/about" className="text-softwhite hover:text-goldcore transition-colors">About</Link>
            <Link to="/contact" className="text-softwhite hover:text-goldcore transition-colors">Contact</Link>
            <Link to="/careers" className="text-softwhite hover:text-goldcore transition-colors">Careers</Link>
          </div>
          <Button variant="gold" size="default" asChild>
            <Link to="/chat">Chat with KnightAI</Link>
          </Button>
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button onClick={() => setIsOpen(!isOpen)} className="text-goldcore p-2">
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && <div className="md:hidden bg-knightblack/95 backdrop-blur-md">
          <div className="px-4 py-5 space-y-4">
            <Link to="/solutions" className="block text-softwhite hover:text-goldcore transition-colors" onClick={() => setIsOpen(false)}>
              Solutions
            </Link>
            <Link to="/insights" className="block text-softwhite hover:text-goldcore transition-colors" onClick={() => setIsOpen(false)}>
              Insights
            </Link>
            <Link to="/about" className="block text-softwhite hover:text-goldcore transition-colors" onClick={() => setIsOpen(false)}>
              About
            </Link>
            <Link to="/contact" className="block text-softwhite hover:text-goldcore transition-colors" onClick={() => setIsOpen(false)}>
              Contact
            </Link>
            <Link to="/careers" className="block text-softwhite hover:text-goldcore transition-colors" onClick={() => setIsOpen(false)}>
              Careers
            </Link>
            <Button variant="gold" size="default" className="w-full" asChild onClick={() => setIsOpen(false)}>
              <Link to="/chat">Chat with KnightAI</Link>
            </Button>
          </div>
        </div>}
    </nav>;
};
export default Navbar;
